
import { Name } from "../prm/name";
import { RadioButton, RADIO_SINGLE_RANDOM_VALUE } from "../prm/radio-button";

class InvestmentKnowledgeRadioButton extends RadioButton {
  constructor(name) {
    super(name, [
      new Name("limited", "Limited"),
      new Name("moderate", "Moderate"),
      new Name("extensive", "Extensive"),
      new Name("none", "None"),
    ], [], RADIO_SINGLE_RANDOM_VALUE);
  }
}

export { InvestmentKnowledgeRadioButton };
